var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBobaAvatar3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 334"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5 40C31.8218 40 41 31.0457 41 20C41 8.95431 31.8218 0 20.5 0C9.17816 0 0 8.95431 0 20C0 31.0457 9.17816 40 20.5 40Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.00001 22C9.20915 22 11 20.2091 11 18C11 15.7909 9.20915 14 7.00001 14C4.79086 14 3 15.7909 3 18C3 20.2091 4.79086 22 7.00001 22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.5 16C22.9853 16 25 13.9853 25 11.5C25 9.01472 22.9853 7 20.5 7C18.0147 7 16 9.01472 16 11.5C16 13.9853 18.0147 16 20.5 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.00001 23C8.65686 23 10 21.6569 10 20C10 18.3431 8.65686 17 7.00001 17C5.34315 17 4 18.3431 4 20C4 21.6569 5.34315 23 7.00001 23Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20 17C21.6569 17 23 15.6569 23 14C23 12.3431 21.6569 11 20 11C18.3432 11 17 12.3431 17 14C17 15.6569 18.3432 17 20 17Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M31.9485 16L29.0826 16.2368C28.7965 16.2401 28.5228 16.3343 28.3184 16.4999C28.1181 16.6687 28.0041 16.8948 28 17.1312C28.0089 17.3591 28.1228 17.5756 28.3184 17.7364C28.4151 17.8233 28.5336 17.8918 28.6655 17.9373C28.7975 17.9827 28.9398 18.0039 29.0826 17.9994L31.9485 17.7626C32.225 17.758 32.4882 17.6635 32.6809 17.4996C32.8793 17.3404 32.9937 17.1229 32.9993 16.8945C33.0047 16.7765 32.9791 16.6589 32.9241 16.5499C32.8691 16.4409 32.7861 16.343 32.6809 16.2631C32.4772 16.1128 32.2204 16.0206 31.9485 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M7.32871 30.7508L8.44911 28.1024C8.54174 27.8316 8.71674 27.6011 8.93784 27.4586C9.16086 27.3211 9.41122 27.2835 9.63709 27.3535C9.85074 27.4332 10.0208 27.609 10.1124 27.845C10.1648 27.9641 10.1929 28.098 10.1948 28.2375C10.1967 28.3771 10.1724 28.5189 10.1235 28.6532L9.00309 31.3015C8.91228 31.5628 8.74026 31.7832 8.52435 31.9151C8.31111 32.0538 8.06881 32.0945 7.85004 32.0285C7.73624 31.9967 7.63258 31.9356 7.54621 31.8493C7.45983 31.763 7.3928 31.6537 7.34977 31.5287C7.27065 31.2883 7.26326 31.0155 7.32871 30.7508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M28.2183 11.477L27.0631 13.7874C26.979 13.9944 26.979 14.2221 27.0631 14.4291C27.0954 14.5384 27.1521 14.6403 27.2297 14.7287C27.3073 14.817 27.404 14.8898 27.5139 14.9425C27.7412 15.0192 27.9911 15.0192 28.2183 14.9425C28.3383 14.9131 28.4502 14.8614 28.5472 14.7908C28.6442 14.7201 28.7241 14.6319 28.7819 14.5318L29.9372 12.2471C30.0209 12.0312 30.0209 11.7956 29.9372 11.5797C29.8527 11.3682 29.6943 11.1878 29.4864 11.0663C29.2518 10.9779 28.9883 10.9779 28.7537 11.0663C28.6393 11.0916 28.5323 11.139 28.4399 11.2055C28.3475 11.2719 28.2719 11.3558 28.2183 11.4514V11.477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M5.00993 25.3064L7.56556 24.9309C7.78854 24.9157 8.00479 24.9868 8.17518 25.1315C8.26887 25.1963 8.34802 25.282 8.4077 25.3833C8.46738 25.4846 8.50631 25.5992 8.522 25.7201C8.52381 25.96 8.44573 26.1973 8.30189 26.3893C8.23648 26.494 8.15242 26.5842 8.05498 26.6542C7.95754 26.7243 7.8488 26.7726 7.73562 26.7963L5.2044 27.1798C4.9731 27.1919 4.74933 27.1183 4.5704 26.9712C4.39586 26.8249 4.274 26.6181 4.22358 26.3826C4.21288 26.1321 4.29522 25.8818 4.45251 25.6866C4.51225 25.5858 4.59078 25.499 4.68278 25.432C4.77479 25.365 4.87809 25.3194 4.98555 25.2984L5.00993 25.3064Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBobaAvatar3);
export default __webpack_public_path__ + "static/media/boba-avatar-3.e5aa7cc7.svg";
export { ForwardRef as ReactComponent };